import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7 22L3 18L7 14V17H17V13H19V18C19 18.5523 18.5523 19 18 19H7V22ZM7 11H5V6C5 5.44772 5.44772 5 6 5H17V2L21 6L17 10V7H7V11Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Repeat"
);
